<template>
  <!-- page-wrapper Start-->
  <div class="page-wrapper compact-wrapper" id="pageWrapper">
    <div class="page-body-wrapper">
      <div class="page-body">
        <!-- Breadcrumb & Title -->
        <div class="container-fluid">
          <div class="page-title">
            <div class="row">
              <div class="col-12 col-sm-6">
                <h3>Profile Details</h3>
              </div>
              <div class="col-12 col-sm-6">
                <ol class="breadcrumb">
                  <li class="breadcrumb-item">
                    <a class="home-item" href="/"><i data-feather="home"></i></a>
                  </li>
                  <li class="breadcrumb-item">Dashboard</li>
                  <li class="breadcrumb-item active">Profile Details</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        <!-- Breadcrumb & Title -->

        <!-- Container-fluid starts-->
        <div class="container-fluid">
          <div class="edit-profile">
            <div class="row">
              <div class="col-xl-12">
                <form class="card">
                  <div class="card-header pb-0">
                    <!-- <h4 class="card-title mb-0">Edit Profile</h4> -->
                    <div class="card-options">
                      <a class="card-options-collapse" href="#" data-bs-toggle="card-collapse"><i
                          class="fe fe-chevron-up"></i></a><a class="card-options-remove" href="#"
                        data-bs-toggle="card-remove"><i class="fe fe-x"></i></a>
                    </div>
                  </div>
                  <div class="card-body">
                    <div class="row ">
                      <div class="col-12 d-flex justify-content-center">
                        <div class="col-xl-6 col-md-6 dash-xl-50">
                          <div class="card pb-0 o-hidden earning-card">
                            <div class="card-header earning-back"></div>
                            <div class="card-body p-0">
                              <div class="earning-content" style="position: relative;"><img class="img-fluid"
                                  src="https://img.icons8.com/color/480/person-male.png" alt=""
                                  style="max-width: 150px"><a href="blog-single.html">
                                  <h4>Account Balance</h4>
                                </a>
                                <h4 v-if="data?.customerAccountsData?.length > 0" style="color: green; font-weight: 'bolder';">
                                  {{ 'BDT ' + parseInt(Number(data?.customerAccountsData[0].amount)) }}</h4>
                                <div id="earning-chart" style="min-height: 120px;">
                                  <div id="apexcharts9ha7oxyh"
                                    class="apexcharts-canvas apexcharts9ha7oxyh apexcharts-theme-light"
                                    style="width: 553px; height: 105px;"><svg id="SvgjsSvg1280" width="553" height="105"
                                      xmlns="http://www.w3.org/2000/svg" version="1.1"
                                      xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs"
                                      class="apexcharts-svg apexcharts-zoomable" xmlns:data="ApexChartsNS"
                                      transform="translate(0, 0)" style="background: transparent;">
                                      <g id="SvgjsG1282" class="apexcharts-inner apexcharts-graphical"
                                        transform="translate(0, -5)">
                                        <defs id="SvgjsDefs1281">
                                          <clipPath id="gridRectMask9ha7oxyh">
                                            <rect id="SvgjsRect1303" width="560" height="98" x="-3.5" y="-1.5" rx="0"
                                              ry="0" opacity="1" stroke-width="0" stroke="none" stroke-dasharray="0"
                                              fill="#fff"></rect>
                                          </clipPath>
                                          <clipPath id="gridRectMarkerMask9ha7oxyh">
                                            <rect id="SvgjsRect1304" width="557" height="99" x="-2" y="-2" rx="0" ry="0"
                                              opacity="1" stroke-width="0" stroke="none" stroke-dasharray="0"
                                              fill="#fff">
                                            </rect>
                                          </clipPath>
                                          <linearGradient id="SvgjsLinearGradient1309" x1="0" y1="0" x2="0" y2="1">
                                            <stop id="SvgjsStop1310" stop-opacity="0.65"
                                              stop-color="rgba(99,98,231,0.65)" offset="0"></stop>
                                            <stop id="SvgjsStop1311" stop-opacity="0.3"
                                              stop-color="rgba(177,177,243,0.3)" offset="1"></stop>
                                            <stop id="SvgjsStop1312" stop-opacity="0.3"
                                              stop-color="rgba(177,177,243,0.3)" offset="1"></stop>
                                          </linearGradient>
                                        </defs>
                                        <g id="SvgjsG1315" class="apexcharts-xaxis" transform="translate(0, 0)">
                                          <g id="SvgjsG1316" class="apexcharts-xaxis-texts-g"
                                            transform="translate(0, -4)"></g>
                                        </g>
                                        <g id="SvgjsG1328" class="apexcharts-grid">
                                          <g id="SvgjsG1329" class="apexcharts-gridlines-horizontal"
                                            style="display: none;">
                                            <line id="SvgjsLine1339" x1="0" y1="0" x2="553" y2="0" stroke="#e0e0e0"
                                              stroke-dasharray="0" class="apexcharts-gridline"></line>
                                            <line id="SvgjsLine1340" x1="0" y1="15.833333333333334" x2="553"
                                              y2="15.833333333333334" stroke="#e0e0e0" stroke-dasharray="0"
                                              class="apexcharts-gridline"></line>
                                            <line id="SvgjsLine1341" x1="0" y1="31.666666666666668" x2="553"
                                              y2="31.666666666666668" stroke="#e0e0e0" stroke-dasharray="0"
                                              class="apexcharts-gridline"></line>
                                            <line id="SvgjsLine1342" x1="0" y1="47.5" x2="553" y2="47.5"
                                              stroke="#e0e0e0" stroke-dasharray="0" class="apexcharts-gridline"></line>
                                            <line id="SvgjsLine1343" x1="0" y1="63.333333333333336" x2="553"
                                              y2="63.333333333333336" stroke="#e0e0e0" stroke-dasharray="0"
                                              class="apexcharts-gridline"></line>
                                            <line id="SvgjsLine1344" x1="0" y1="79.16666666666667" x2="553"
                                              y2="79.16666666666667" stroke="#e0e0e0" stroke-dasharray="0"
                                              class="apexcharts-gridline"></line>
                                            <line id="SvgjsLine1345" x1="0" y1="95" x2="553" y2="95" stroke="#e0e0e0"
                                              stroke-dasharray="0" class="apexcharts-gridline"></line>
                                          </g>
                                          <g id="SvgjsG1330" class="apexcharts-gridlines-vertical"
                                            style="display: none;">
                                          </g>
                                          <line id="SvgjsLine1331" x1="1.4401041666666667" y1="96"
                                            x2="1.4401041666666667" y2="102" stroke="#e0e0e0" stroke-dasharray="0"
                                            class="apexcharts-xaxis-tick">
                                          </line>
                                          <line id="SvgjsLine1332" x1="70.56510416666666" y1="96" x2="70.56510416666666"
                                            y2="102" stroke="#e0e0e0" stroke-dasharray="0"
                                            class="apexcharts-xaxis-tick">
                                          </line>
                                          <line id="SvgjsLine1333" x1="139.69010416666666" y1="96"
                                            x2="139.69010416666666" y2="102" stroke="#e0e0e0" stroke-dasharray="0"
                                            class="apexcharts-xaxis-tick">
                                          </line>
                                          <line id="SvgjsLine1334" x1="208.81510416666666" y1="96"
                                            x2="208.81510416666666" y2="102" stroke="#e0e0e0" stroke-dasharray="0"
                                            class="apexcharts-xaxis-tick">
                                          </line>
                                          <line id="SvgjsLine1335" x1="277.94010416666663" y1="96"
                                            x2="277.94010416666663" y2="102" stroke="#e0e0e0" stroke-dasharray="0"
                                            class="apexcharts-xaxis-tick">
                                          </line>
                                          <line id="SvgjsLine1336" x1="347.06510416666663" y1="96"
                                            x2="347.06510416666663" y2="102" stroke="#e0e0e0" stroke-dasharray="0"
                                            class="apexcharts-xaxis-tick">
                                          </line>
                                          <line id="SvgjsLine1337" x1="416.19010416666663" y1="96"
                                            x2="416.19010416666663" y2="102" stroke="#e0e0e0" stroke-dasharray="0"
                                            class="apexcharts-xaxis-tick">
                                          </line>
                                          <line id="SvgjsLine1338" x1="485.31510416666663" y1="96"
                                            x2="485.31510416666663" y2="102" stroke="#e0e0e0" stroke-dasharray="0"
                                            class="apexcharts-xaxis-tick">
                                          </line>
                                          <line id="SvgjsLine1347" x1="0" y1="95" x2="553" y2="95" stroke="transparent"
                                            stroke-dasharray="0"></line>
                                          <line id="SvgjsLine1346" x1="0" y1="1" x2="0" y2="95" stroke="transparent"
                                            stroke-dasharray="0"></line>
                                        </g>
                                        <g id="SvgjsG1305" class="apexcharts-area-series apexcharts-plot-series">
                                          <g id="SvgjsG1306" class="apexcharts-series" seriesName="Seriesx1"
                                            data:longestSeries="true" rel="1" data:realIndex="0">
                                            <path id="SvgjsPath1313"
                                              d="M 0 95L 0 85.5C 12.096874999999999 85.5 22.465625000000003 63.33333333333333 34.5625 63.33333333333333C 46.659375 63.33333333333333 57.028125 71.25 69.125 71.25C 81.221875 71.25 91.590625 31.666666666666664 103.6875 31.666666666666664C 139.978125 31.666666666666664 171.084375 66.5 207.375 66.5C 219.471875 66.5 229.840625 63.33333333333333 241.9375 63.33333333333333C 254.034375 63.33333333333333 264.403125 66.5 276.5 66.5C 288.596875 66.5 298.965625 58.58333333333333 311.0625 58.58333333333333C 323.159375 58.58333333333333 333.528125 66.5 345.625 66.5C 381.915625 66.5 413.021875 39.58333333333333 449.3125 39.58333333333333C 461.409375 39.58333333333333 471.778125 47.5 483.875 47.5C 495.971875 47.5 506.340625 7.916666666666657 518.4375 7.916666666666657C 530.534375 7.916666666666657 540.903125 95 553 95C 553 95 553 95 553 95M 553 95z"
                                              fill="url(#SvgjsLinearGradient1309)" fill-opacity="1" stroke-opacity="1"
                                              stroke-linecap="round" stroke-width="0" stroke-dasharray="0"
                                              class="apexcharts-area" index="0" clip-path="url(#gridRectMask9ha7oxyh)"
                                              pathTo="M 0 95L 0 85.5C 12.096874999999999 85.5 22.465625000000003 63.33333333333333 34.5625 63.33333333333333C 46.659375 63.33333333333333 57.028125 71.25 69.125 71.25C 81.221875 71.25 91.590625 31.666666666666664 103.6875 31.666666666666664C 139.978125 31.666666666666664 171.084375 66.5 207.375 66.5C 219.471875 66.5 229.840625 63.33333333333333 241.9375 63.33333333333333C 254.034375 63.33333333333333 264.403125 66.5 276.5 66.5C 288.596875 66.5 298.965625 58.58333333333333 311.0625 58.58333333333333C 323.159375 58.58333333333333 333.528125 66.5 345.625 66.5C 381.915625 66.5 413.021875 39.58333333333333 449.3125 39.58333333333333C 461.409375 39.58333333333333 471.778125 47.5 483.875 47.5C 495.971875 47.5 506.340625 7.916666666666657 518.4375 7.916666666666657C 530.534375 7.916666666666657 540.903125 95 553 95C 553 95 553 95 553 95M 553 95z"
                                              pathFrom="M -1 95L -1 95L 34.5625 95L 69.125 95L 103.6875 95L 207.375 95L 241.9375 95L 276.5 95L 311.0625 95L 345.625 95L 449.3125 95L 483.875 95L 518.4375 95L 553 95">
                                            </path>
                                            <path id="SvgjsPath1314"
                                              d="M 0 85.5C 12.096874999999999 85.5 22.465625000000003 63.33333333333333 34.5625 63.33333333333333C 46.659375 63.33333333333333 57.028125 71.25 69.125 71.25C 81.221875 71.25 91.590625 31.666666666666664 103.6875 31.666666666666664C 139.978125 31.666666666666664 171.084375 66.5 207.375 66.5C 219.471875 66.5 229.840625 63.33333333333333 241.9375 63.33333333333333C 254.034375 63.33333333333333 264.403125 66.5 276.5 66.5C 288.596875 66.5 298.965625 58.58333333333333 311.0625 58.58333333333333C 323.159375 58.58333333333333 333.528125 66.5 345.625 66.5C 381.915625 66.5 413.021875 39.58333333333333 449.3125 39.58333333333333C 461.409375 39.58333333333333 471.778125 47.5 483.875 47.5C 495.971875 47.5 506.340625 7.916666666666657 518.4375 7.916666666666657C 530.534375 7.916666666666657 540.903125 95 553 95"
                                              fill="none" fill-opacity="1" stroke="#6362e7" stroke-opacity="1"
                                              stroke-linecap="round" stroke-width="3" stroke-dasharray="0"
                                              class="apexcharts-area" index="0" clip-path="url(#gridRectMask9ha7oxyh)"
                                              pathTo="M 0 85.5C 12.096874999999999 85.5 22.465625000000003 63.33333333333333 34.5625 63.33333333333333C 46.659375 63.33333333333333 57.028125 71.25 69.125 71.25C 81.221875 71.25 91.590625 31.666666666666664 103.6875 31.666666666666664C 139.978125 31.666666666666664 171.084375 66.5 207.375 66.5C 219.471875 66.5 229.840625 63.33333333333333 241.9375 63.33333333333333C 254.034375 63.33333333333333 264.403125 66.5 276.5 66.5C 288.596875 66.5 298.965625 58.58333333333333 311.0625 58.58333333333333C 323.159375 58.58333333333333 333.528125 66.5 345.625 66.5C 381.915625 66.5 413.021875 39.58333333333333 449.3125 39.58333333333333C 461.409375 39.58333333333333 471.778125 47.5 483.875 47.5C 495.971875 47.5 506.340625 7.916666666666657 518.4375 7.916666666666657C 530.534375 7.916666666666657 540.903125 95 553 95"
                                              pathFrom="M -1 95L -1 95L 34.5625 95L 69.125 95L 103.6875 95L 207.375 95L 241.9375 95L 276.5 95L 311.0625 95L 345.625 95L 449.3125 95L 483.875 95L 518.4375 95L 553 95">
                                            </path>
                                            <g id="SvgjsG1307" class="apexcharts-series-markers-wrap"
                                              data:realIndex="0">
                                              <g class="apexcharts-series-markers">
                                                <circle id="SvgjsCircle1355" r="0" cx="0" cy="0"
                                                  class="apexcharts-marker wxippgdi2 no-pointer-events" stroke="#ffffff"
                                                  fill="#6362e7" fill-opacity="1" stroke-width="2" stroke-opacity="0.9"
                                                  default-marker-size="0"></circle>
                                              </g>
                                            </g>
                                          </g>
                                          <g id="SvgjsG1308" class="apexcharts-datalabels" data:realIndex="0"></g>
                                        </g>
                                        <line id="SvgjsLine1348" x1="0" y1="0" x2="553" y2="0" stroke="#b6b6b6"
                                          stroke-dasharray="0" stroke-width="1" class="apexcharts-ycrosshairs"></line>
                                        <line id="SvgjsLine1349" x1="0" y1="0" x2="553" y2="0" stroke-dasharray="0"
                                          stroke-width="0" class="apexcharts-ycrosshairs-hidden"></line>
                                        <g id="SvgjsG1350" class="apexcharts-yaxis-annotations"></g>
                                        <g id="SvgjsG1351" class="apexcharts-xaxis-annotations"></g>
                                        <g id="SvgjsG1352" class="apexcharts-point-annotations">
                                          <circle id="SvgjsCircle1353" r="6" cx="234.73697916666666"
                                            cy="63.33333333333333" class="apexcharts-point-annotation-marker  "
                                            stroke="#6362e7" fill="#ffffff" fill-opacity="1" stroke-width="3"
                                            stroke-opacity="1"></circle><text id="SvgjsText1354"
                                            font-family="Helvetica, Arial, sans-serif" x="234.73697916666666"
                                            y="46.33333333333333" text-anchor="middle" dominant-baseline="auto"
                                            font-size="11px" font-weight="400" fill="#373d3f"
                                            class="apexcharts-text apexcharts-point-annotation-label  " rel="0"
                                            style="font-family: Helvetica, Arial, sans-serif;"></text>
                                        </g>
                                        <rect id="SvgjsRect1356" width="0" height="0" x="0" y="0" rx="0" ry="0"
                                          opacity="1" stroke-width="0" stroke="none" stroke-dasharray="0" fill="#fefefe"
                                          class="apexcharts-zoom-rect"></rect>
                                        <rect id="SvgjsRect1357" width="0" height="0" x="0" y="0" rx="0" ry="0"
                                          opacity="1" stroke-width="0" stroke="none" stroke-dasharray="0" fill="#fefefe"
                                          class="apexcharts-selection-rect"></rect>
                                      </g>
                                      <g id="SvgjsG1326" class="apexcharts-yaxis" rel="0" transform="translate(-8, 0)">
                                        <g id="SvgjsG1327" class="apexcharts-yaxis-texts-g"></g>
                                      </g>
                                      <g id="SvgjsG1283" class="apexcharts-annotations"></g>
                                    </svg>
                                    <div class="apexcharts-legend" style="max-height: 52.5px;"></div>
                                    <div class="apexcharts-tooltip apexcharts-theme-light">
                                      <div class="apexcharts-tooltip-series-group" style="order: 1;"><span
                                          class="apexcharts-tooltip-marker"
                                          style="background-color: rgb(99, 98, 231);"></span>
                                        <div class="apexcharts-tooltip-text"
                                          style="font-family: Helvetica, Arial, sans-serif; font-size: 12px;">
                                          <div class="apexcharts-tooltip-y-group"><span
                                              class="apexcharts-tooltip-text-label"></span><span
                                              class="apexcharts-tooltip-text-value"></span></div>
                                          <div class="apexcharts-tooltip-z-group"><span
                                              class="apexcharts-tooltip-text-z-label"></span><span
                                              class="apexcharts-tooltip-text-z-value"></span></div>
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      class="apexcharts-yaxistooltip apexcharts-yaxistooltip-0 apexcharts-yaxistooltip-left apexcharts-theme-light">
                                      <div class="apexcharts-yaxistooltip-text"></div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                    <div class="row">

                      <div class="col-md-3">
                        <div class="mb-3">
                          <label class="form-label">Name</label>
                          <input class="form-control" v-model="this.data.name" type="text" placeholder="Enter Full Name"
                            readonly />
                        </div>
                      </div>
                      <div class="col-sm-6 col-md-3">
                        <div class="mb-3">
                          <label class="form-label">Phone</label>
                          <input class="form-control" type="text" v-model="data.phone" placeholder="Enter Phone Number"
                            readonly />
                        </div>
                      </div>
                      <div class="col-sm-6 col-md-3">
                        <div class="mb-3">
                          <label class="form-label">Email address</label>
                          <input class="form-control" v-model="data.email" type="email" placeholder="Enter Email"
                            readonly />
                        </div>
                      </div>
                      <div class="col-sm-6 col-md-3">
                        <div class="mb-3">
                          <label class="form-label">Initial Date</label>
                          <input class="form-control" v-model="data.initial_date" type="date" placeholder="Enter Date"
                            readonly />
                        </div>
                      </div>
                      <div class="col-sm-6 col-md-3">
                        <div class="mb-3">
                          <label class="form-label">Flat</label>
                          <input class="form-control" v-model="data.flat_no" type="text" placeholder="Enter Flat No."
                            readonly />
                        </div>
                      </div>
                      <div class="col-sm-6 col-md-3">
                        <div class="mb-3">
                          <label class="form-label">House</label>
                          <input class="form-control" v-model="data.house_no" type="text" placeholder="Enter House No."
                            readonly />
                        </div>
                      </div>
                      <div class="col-sm-6 col-md-3">
                        <div class="mb-3">
                          <label class="form-label">Road</label>
                          <input class="form-control" v-model="data.road_no" type="text" placeholder="Enter Road No."
                            readonly />
                        </div>
                      </div>
                      <div class="col-sm-6 col-md-3">
                        <div class="mb-3">
                          <label class="form-label">Block</label>
                          <input class="form-control" v-model="data.block_no" type="text" placeholder="Enter Block No."
                            readonly />
                        </div>
                      </div>
                      <div class="col-sm-6 col-md-4">
                        <div class="mb-3">
                          <label class="form-label">District</label>
                          <select class="f1-email form-control" v-model="data.district"
                            v-if="this.districtList.length > 0" disabled>
                            <option value="" selected>Select District</option>
                            <option :key="district.id" v-for="district in districtList" :value="district.id" @change="
                              () => {
                                this.district = district.id;
                              }
                            ">
                              {{ district.name }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="mb-3">
                          <label class="form-label">Area One</label>
                          <select class="f1-email form-control" v-model="data.area_one"
                            v-if="this.districtList.length > 0" disabled>
                            <option value="" selected>Select Area One</option>
                            <option :key="district.id" v-for="district in districtList" :value="district.id" @change="
                              () => {
                                this.area_one = district.id;
                              }
                            ">
                              {{ district.name }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="mb-3">
                          <label class="form-label">Area Two</label>
                          <select class="f1-email form-control" v-model="data.area_two"
                            v-if="this.districtList.length > 0" disabled>
                            <option value="" selected>Select Area Two</option>
                            <option :key="district.id" v-for="district in districtList" :value="district.id" @change="
                              () => {
                                this.area_two = district.id;
                              }
                            ">
                              {{ district.name }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="col-sm-6 col-md-4">
                        <div class="mb-3">
                          <label class="form-label">POP</label>
                          <select class="form-control" id="f1-first-name" type="text" v-model="data.pop_id"
                            placeholder="Enter POP" required="" disabled>
                            <option value="" disabled>Select POP</option>
                            <option v-for="p in popList" :key="p.id" :value="p.id">{{ p.name }}</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-sm-6 col-md-4">
                        <div class="mb-3">
                          <label class="form-label">remarks</label>
                          <input class="form-control" id="f1-first-name" type="text" v-model="data.remarks"
                            placeholder="Enter remarkss" required="" readonly />
                        </div>
                      </div>
                      <div class="col-sm-6 col-md-4">
                        <div class="mb-3">
                          <label class="form-label">Bandwidth Type</label>
                          <select class="form-control" id="f1-first-name" type="text" v-model="data.bandwidth_type"
                            placeholder="Select Type" required="" disabled>
                            <option value="1">Dedicated</option>
                            <option value="2">Shared</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-sm-6 col-md-4">
                        <div class="mb-3">
                          <label class="form-label">Bandwidth</label>
                          <input class="form-control" id="f1-first-name" type="text" v-model="data.bandwidth"
                            placeholder="Enter Bandwidth" required="" readonly />
                        </div>
                      </div>
                      <div class="col-sm-6 col-md-4">
                        <div class="mb-3">
                          <label class="form-label">Billing Date</label>
                          <input class="form-control" id="f1-first-name" type="number" v-model="data.billing_date"
                            placeholder="Enter date" required="" readonly />
                        </div>
                      </div>
                      <div class="col-lg-4">
                        <div class="mb-2">
                          <label for="f1-first-name">MRC</label>
                          <input class="form-control" id="f1-first-name" type="Number" v-model="data.mrc"
                            placeholder="0" required="" readonly />
                        </div>
                      </div>
                      <div class="col-lg-4">
                        <div class="mb-2">
                          <label for="f1-first-name">OTC</label>
                          <input class="form-control" id="f1-first-name" type="Number" v-model="data.otc"
                            placeholder="0" required="" readonly />
                        </div>
                      </div>
                      <div class="col-lg-4">
                        <div class="mb-2">
                          <label for="f1-first-name">Total(including VAT)</label>
                          <input class="form-control" id="f1-first-name" type="Number"
                            v-model="data.total_price_with_vat" placeholder="0" required="" readonly />
                        </div>
                      </div>
                      <div class="col-lg-4">
                        <div class="mb-2">
                          <label for="f1-first-name">Opening Balance</label>
                          <input class="form-control" id="f1-first-name" type="Number" v-model="data.opening_balance"
                            placeholder="0" required="" readonly />
                        </div>
                      </div>
                      <div class="col-lg-4">
                        <div class="mb-2">
                          <label for="f1-first-name">Recurring Period</label>
                          <input class="form-control" id="f1-first-name" type="text" v-model="data.recuring_period"
                            placeholder="Enter Recurring Periods" required="" readonly />
                        </div>
                      </div>
                      <div class="col-lg-8"></div>
                    </div>
                  </div>
                  <!-- <div class="card-footer text-end">
                    <button class="btn btn-primary" type="button" @click="updateCustomer">
                      Update Profile
                    </button>
                  </div> -->
                </form>
                <!-- Container-fluid Ends-->
              </div>
            </div>
          </div>
        </div>
        <!-- Container-fluid starts-->
      </div>
    </div>
  </div>
</template>

<script>
// import CustomerAPI from "../../services/customer.API";
import areaRelatedAPI from "../../services/areaRelatedAPI";
import customerAPI from "../../services/customer.API";
import pop_typeAPI from '../../services/pop_type.API';

export default {
  name: "CustomerEdit",
  data() {
    return {
      data: {
        active: 1,
        customer_type: 1,
        name: "",
        email: "",
        phone: "",
        companyName: "",
        companyPhone: "",
        product_details: "",
        initial_date: "",
        flat_no: "",
        house_no: "",
        road_no: "",
        block_no: "",
        district: "",
        area_one: "",
        area_two: "",
        pop_id: "",
        remarks: "",
        bandwidth_type: "",
        bandwidth: "",
        billing_date: "",
        mrc: "",
        otc: "",
        total_price_with_vat: "",
        opening_balance: "",
        recuring_period: "",
        owner_designation: "owner designation",
        owner_email: "",
        owner_name: "",
        owner_phone_one: "",
        owner_phone_two: "",
        technical_name: "",
        technical_designation: "",
        technical_phone_one: "",
        technical_phone_two: "",
        technical_email: "",
        billing_contact_name: "",
        billing_contact_designation: "",
        billing_contact_phone_one: "",
        billing_contact_phone_two: "",
        billing_contact_email: "",
        contractAddressList: [
          {
            name: "",
            designation: "",
            phone_one: "",
            phone_two: "",
            email: "",
          },
        ],
      },
      districtList: [],
      customer_id: "",
      popList: []
    };
  },
  mounted() {
    // pop list
    pop_typeAPI.getList().then((response) => {
      this.popList = response.data.data;
    });
    // get District
    // this.getDistrictList();
    areaRelatedAPI.districtList().then(
      (response) => {
        this.districtList = response.data.data.map((e) => {
          return {
            ...e,
            code: e.id,
            label: e.name,
          };
        });
      },
      (err) => {
        if (err.response.data.success === false) {
          this.districtList = [];
        }
      }
    );

    // get data
    // var url = window.location.href;
    // var id = Number(url.substring(url.lastIndexOf("/") + 1));
    // console.log(id);
    // if (id) {
    // this.customer_id = id;
    customerAPI.getProfileDetails().then((response) => {
      this.data = response.data.data;
      console.log(this.data);
    }, err => {
      this.$moshaToast(err.response.data.message, {
        type: "danger",
        position: "top-right",
        showIcon: true,
      });
    });
    // }
  },

};
</script>
<style scoped>
fieldset.d-block {
  background: white;
  border-radius: 15px;
  border: 1px solid white;
  padding: 25px;
}

.card.pb-0.o-hidden.earning-card {
  margin-bottom: 30px;
  border: none;
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
  letter-spacing: 0.5px;
  border-radius: 15px;
  -webkit-box-shadow: 0px 4px 30px rgb(95 94 231 / 7%);
  box-shadow: 0px 4px 30px rgb(95 94 231 / 7%);
}
</style>
